const LOAD_DATA_MASTER_JOB_POSITION         = 'LOAD_DATA_MASTER_JOB_POSITION'
const LOAD_DATA_MASTER_JOB_POSITION_SUCCESS = 'LOAD_DATA_MASTER_JOB_POSITION_SUCCESS'
const LOAD_DATA_MASTER_JOB_POSITION_FAILED  = 'LOAD_DATA_MASTER_JOB_POSITION_FAILED'
const UNMOUNT_DATA_MASTER_JOB_POSITION      = 'UNMOUNT_DATA_MASTER_JOB_POSITION'

const initialState = {
  loading: true,
  data: null,
  message: null,
  meta: null
}

const jobPositionReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DATA_MASTER_JOB_POSITION:
      return {
        ...state,
        loading: true,
        data: null,
        meta: null
      }
    case LOAD_DATA_MASTER_JOB_POSITION_SUCCESS:
      return {
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        meta: action.payload.meta
      }
    case LOAD_DATA_MASTER_JOB_POSITION_FAILED:
      return {
        ...state, 
        loading: false,
        data: null,
        message: 'FAILED',
        meta: null
      }
    case UNMOUNT_DATA_MASTER_JOB_POSITION:
      return { 
        ...state, 
        loading: true,
        data: null,
        meta: null
      }
    default:
      return state
  }
}
export default jobPositionReducer